import { render } from "./DataTable.vue?vue&type=template&id=1815f599&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=1815f599&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1815f599"],['__file',"src/views/SpecialAccountManagement/components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1815f599"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1815f599', __exports__)) {
    api.reload('1815f599', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=1815f599&scoped=true", () => {
    api.rerender('1815f599', render)
  })

}


export default __exports__